var map = {
	"./ad.svg": 70385,
	"./ae.svg": 56000,
	"./af.svg": 17011,
	"./ag.svg": 13282,
	"./ai.svg": 53732,
	"./al.svg": 88617,
	"./am.svg": 63256,
	"./ao.svg": 27450,
	"./aq.svg": 71228,
	"./ar.svg": 73551,
	"./arab.svg": 61142,
	"./as.svg": 53502,
	"./asean.svg": 68482,
	"./at.svg": 70881,
	"./au.svg": 79760,
	"./aw.svg": 65842,
	"./ax.svg": 33749,
	"./az.svg": 60327,
	"./ba.svg": 92549,
	"./bb.svg": 56326,
	"./bd.svg": 24056,
	"./be.svg": 99561,
	"./bf.svg": 57626,
	"./bg.svg": 62891,
	"./bh.svg": 47916,
	"./bi.svg": 83373,
	"./bj.svg": 89006,
	"./bl.svg": 13920,
	"./bm.svg": 54481,
	"./bn.svg": 74082,
	"./bo.svg": 4659,
	"./bq.svg": 87221,
	"./br.svg": 74262,
	"./brasil.svg": 46193,
	"./bs.svg": 13799,
	"./bt.svg": 76200,
	"./bv.svg": 15594,
	"./bw.svg": 57563,
	"./by.svg": 83869,
	"./bz.svg": 71774,
	"./ca.svg": 21846,
	"./cc.svg": 73524,
	"./cd.svg": 5147,
	"./cefta.svg": 50925,
	"./cf.svg": 5529,
	"./cg.svg": 23784,
	"./china.svg": 93239,
	"./ci.svg": 19358,
	"./ck.svg": 19260,
	"./cl.svg": 46915,
	"./cm.svg": 97522,
	"./cn.svg": 79265,
	"./co.svg": 80816,
	"./cp.svg": 66711,
	"./cr.svg": 40133,
	"./cu.svg": 5210,
	"./cv.svg": 47145,
	"./cw.svg": 71640,
	"./cx.svg": 74527,
	"./cy.svg": 36590,
	"./cz.svg": 30957,
	"./de.svg": 80115,
	"./dg.svg": 95313,
	"./dj.svg": 68420,
	"./dk.svg": 19589,
	"./dm.svg": 73099,
	"./do.svg": 26601,
	"./dz.svg": 41652,
	"./eac.svg": 15051,
	"./ec.svg": 54986,
	"./ee.svg": 89236,
	"./eg.svg": 89974,
	"./eh.svg": 865,
	"./en.svg": 31215,
	"./er.svg": 20683,
	"./es-ct.svg": 39322,
	"./es-ga.svg": 42667,
	"./es-pv.svg": 52325,
	"./es.svg": 6074,
	"./et.svg": 67173,
	"./eu.svg": 16004,
	"./fi.svg": 98281,
	"./fj.svg": 37114,
	"./fk.svg": 30987,
	"./fm.svg": 44293,
	"./fo.svg": 17847,
	"./fr.svg": 75506,
	"./france.svg": 97427,
	"./ga.svg": 23090,
	"./gb-eng.svg": 65286,
	"./gb-nir.svg": 76133,
	"./gb-sct.svg": 27444,
	"./gb-wls.svg": 14978,
	"./gb.svg": 28129,
	"./gd.svg": 30799,
	"./ge.svg": 10750,
	"./germany.svg": 90437,
	"./gf.svg": 57021,
	"./gg.svg": 28476,
	"./gh.svg": 30715,
	"./gi.svg": 61898,
	"./gl.svg": 17575,
	"./gm.svg": 54358,
	"./gn.svg": 90997,
	"./gp.svg": 74259,
	"./gq.svg": 70530,
	"./gr.svg": 27633,
	"./gs.svg": 13248,
	"./gt.svg": 30719,
	"./gu.svg": 16078,
	"./gw.svg": 51692,
	"./gy.svg": 84698,
	"./hk.svg": 60721,
	"./hm.svg": 63807,
	"./hn.svg": 84780,
	"./hr.svg": 48264,
	"./ht.svg": 87446,
	"./hu.svg": 50663,
	"./ic.svg": 35030,
	"./id.svg": 91865,
	"./ie.svg": 95848,
	"./il.svg": 8801,
	"./im.svg": 17680,
	"./in.svg": 7075,
	"./io.svg": 3762,
	"./iq.svg": 91652,
	"./ir.svg": 46103,
	"./is.svg": 40774,
	"./it.svg": 10185,
	"./je.svg": 16049,
	"./jm.svg": 43785,
	"./jo.svg": 64107,
	"./jp.svg": 91164,
	"./ke.svg": 59090,
	"./kg.svg": 51888,
	"./kh.svg": 28455,
	"./ki.svg": 41334,
	"./km.svg": 72170,
	"./kn.svg": 32921,
	"./kp.svg": 59391,
	"./kr.svg": 83757,
	"./kw.svg": 17184,
	"./ky.svg": 88774,
	"./kz.svg": 87909,
	"./la.svg": 44135,
	"./lb.svg": 79572,
	"./lc.svg": 52181,
	"./li.svg": 21551,
	"./lk.svg": 31997,
	"./lr.svg": 6340,
	"./ls.svg": 57509,
	"./lt.svg": 96410,
	"./lu.svg": 11019,
	"./lv.svg": 60280,
	"./ly.svg": 63167,
	"./ma.svg": 23568,
	"./mc.svg": 40274,
	"./md.svg": 74205,
	"./me.svg": 62012,
	"./mexico.svg": 1819,
	"./mf.svg": 24687,
	"./mg.svg": 62110,
	"./mh.svg": 48281,
	"./mk.svg": 5930,
	"./ml.svg": 77557,
	"./mm.svg": 32628,
	"./mn.svg": 4135,
	"./mo.svg": 64598,
	"./mp.svg": 44817,
	"./mq.svg": 4256,
	"./mr.svg": 94995,
	"./ms.svg": 64418,
	"./mt.svg": 73709,
	"./mu.svg": 38252,
	"./mv.svg": 17279,
	"./mw.svg": 79342,
	"./mx.svg": 89897,
	"./my.svg": 14392,
	"./mz.svg": 53227,
	"./na.svg": 1529,
	"./nc.svg": 21051,
	"./ne.svg": 81333,
	"./nf.svg": 44694,
	"./ng.svg": 7911,
	"./ni.svg": 18465,
	"./nl.svg": 18812,
	"./no.svg": 21135,
	"./np.svg": 10840,
	"./nr.svg": 75034,
	"./nu.svg": 82213,
	"./nz.svg": 60866,
	"./om.svg": 87150,
	"./pa.svg": 3539,
	"./pc.svg": 18737,
	"./pe.svg": 48671,
	"./pf.svg": 69644,
	"./pg.svg": 68589,
	"./ph.svg": 81914,
	"./pk.svg": 50025,
	"./pl.svg": 20582,
	"./pm.svg": 34967,
	"./pn.svg": 91844,
	"./pr.svg": 41168,
	"./ps.svg": 76705,
	"./pt.svg": 63326,
	"./pw.svg": 17501,
	"./py.svg": 91195,
	"./qa.svg": 75612,
	"./re.svg": 23257,
	"./ro.svg": 3715,
	"./rs.svg": 66647,
	"./ru.svg": 81705,
	"./rw.svg": 85675,
	"./sa.svg": 83526,
	"./sb.svg": 15301,
	"./sc.svg": 34404,
	"./sd.svg": 1995,
	"./se.svg": 8122,
	"./sg.svg": 43928,
	"./sh-ac.svg": 15720,
	"./sh-hl.svg": 33012,
	"./sh-ta.svg": 42189,
	"./sh.svg": 54143,
	"./si.svg": 39502,
	"./sj.svg": 22477,
	"./sk.svg": 75116,
	"./sl.svg": 97683,
	"./sm.svg": 93954,
	"./sn.svg": 51057,
	"./so.svg": 36672,
	"./spain.svg": 39737,
	"./sr.svg": 14421,
	"./ss.svg": 76436,
	"./st.svg": 54139,
	"./sv.svg": 34617,
	"./sx.svg": 54223,
	"./sy.svg": 34174,
	"./sz.svg": 80445,
	"./tc.svg": 64541,
	"./td.svg": 30610,
	"./tf.svg": 13904,
	"./tg.svg": 12353,
	"./th.svg": 54934,
	"./tj.svg": 22964,
	"./tk.svg": 67893,
	"./tl.svg": 96266,
	"./tm.svg": 38235,
	"./tn.svg": 56872,
	"./to.svg": 38617,
	"./tr.svg": 28588,
	"./tt.svg": 54754,
	"./tv.svg": 94592,
	"./tw.svg": 35153,
	"./tz.svg": 95204,
	"./ua.svg": 99256,
	"./ug.svg": 31526,
	"./um.svg": 46796,
	"./un.svg": 2143,
	"./united-states-of-america.svg": 27783,
	"./uy.svg": 94640,
	"./uz.svg": 56131,
	"./va.svg": 33953,
	"./vc.svg": 55459,
	"./ve.svg": 74749,
	"./vg.svg": 64303,
	"./vi.svg": 79449,
	"./vn.svg": 23062,
	"./vu.svg": 25837,
	"./wf.svg": 32813,
	"./ws.svg": 66320,
	"./xk.svg": 14625,
	"./xx.svg": 36290,
	"./ye.svg": 37816,
	"./yt.svg": 71705,
	"./za.svg": 70781,
	"./zh.svg": 66772,
	"./zm.svg": 24953,
	"./zw.svg": 88019
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57452;